import { UseForm } from '@brenger/react';
import * as React from 'react';
import { InputSelect, InputText } from '../../../../brenger-shared-ui';
import { translate } from '../../../../utils/localization';
import { normalizeDutchPostalCode } from '../../../../utils/normalisation';
import { RegisterFormFields } from './types';

const countryOptions = [
  { label: 'NL', value: 'NL' },
  { label: 'BE', value: 'BE' },
];

export interface CompanyDetailsProps {
  form: UseForm.Form<RegisterFormFields>;
}

export const CompanyDetails: React.FC<CompanyDetailsProps> = ({ form }) => {
  const onPostalChange = (raw: string): void => {
    const cc = form.data.country_code.value;
    const trimmed = raw.trim();
    let next = trimmed;
    if (trimmed && cc === 'NL') {
      next = normalizeDutchPostalCode(trimmed);
    }
    form.set({ postal_code: next });
  };

  return (
    <>
      <InputText
        className="input-default--space"
        required
        name="user.account.name"
        type="text"
        placeholder={translate('form.fields.account.account_name.label')}
        value={form.data.account_name.value}
        onChange={account_name => form.set({ account_name })}
        meta={{
          error: form.getError('account_name'),
          showError: form.data.account_name.isDirty,
        }}
      />
      <InputText
        className="input-default--space"
        required
        name="user.account.address.line1"
        type="text"
        placeholder={translate('form.fields.address.line1.label')}
        value={form.data.address_line1.value}
        onChange={address_line1 => form.set({ address_line1 })}
        meta={{
          error: form.getError('address_line1'),
          showError: form.data.address_line1.isDirty,
        }}
      />
      <InputText
        className="input-default--space"
        required
        name="user.account.address.postal_code"
        type="text"
        placeholder={translate('form.fields.address.postal_code.label')}
        value={form.data.postal_code.value}
        onChange={onPostalChange}
        meta={{
          error: form.getError('postal_code'),
          showError: form.data.postal_code.isDirty,
        }}
      />
      <InputText
        className="input-default--space"
        required
        name="user.account.address.locality"
        type="text"
        placeholder={translate('form.fields.address.locality.label')}
        value={form.data.locality.value}
        onChange={locality => form.set({ locality })}
        meta={{
          error: form.getError('locality'),
          showError: form.data.locality.isDirty,
        }}
      />
      <InputSelect
        className="input-default--space"
        required
        name="user.account.address.country_code"
        addEmptyOption={false}
        value={form.data.country_code.value}
        onChange={country_code => form.set({ country_code })}
        options={countryOptions}
        meta={{
          error: form.getError('country_code'),
          showError: form.data.country_code.isDirty,
        }}
      />
    </>
  );
};

export default CompanyDetails;
